import informaDefaultImage from '../../../../../assets/images/informaconnect/Informa-default-image.png';
import styles from './LoaderWrapper.module.scss';
import cn from 'classnames';
import { HTMLAttributes, PropsWithChildren } from 'react';
import { PropsWithTestId } from '../../../../../types';

export interface LoaderWrapperProps
  extends PropsWithTestId<HTMLAttributes<HTMLDivElement>> {
  loading: boolean;
}

export const LoaderWrapper = (props: PropsWithChildren<LoaderWrapperProps>) => {
  const { testId, className, loading, children, ...restProps } = props;

  const wrapperClassName = cn(styles.wrapper, {
    [styles.wrapperLoading]: loading,
  });

  return (
    <div className={wrapperClassName}>
      {loading ? (
        <img
          {...restProps}
          src={informaDefaultImage}
          alt=""
          className={cn(styles.loader, className)}
          data-testid={testId}
        />
      ) : (
        children
      )}
    </div>
  );
};

LoaderWrapper.defaultProps = {
  testId: 'loader-wrapper',
};
